module.exports = __webpack_public_path__ + "static/media/dress-4.981dd867.jpg";